import { render, staticRenderFns } from "./GrupoForm.vue?vue&type=template&id=ea543fba&scoped=true"
import script from "./GrupoForm.vue?vue&type=script&lang=js"
export * from "./GrupoForm.vue?vue&type=script&lang=js"
import style0 from "./GrupoForm.vue?vue&type=style&index=0&id=ea543fba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea543fba",
  null
  
)

export default component.exports